export default "__VITE_ASSET__CUo14BsH__"